import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";

const DriverAdditionalStopPopup = ({ task, classes, isCanceledDispatch }) => {
  return (
    <div className={classes.driverAdditionalStop}>
      <PopupFieldRenderer
        label={task.stopTypeLabel}
        value={task.arrivalTime}
        labelClassName={`${classes.headerLabel} ${
          isCanceledDispatch ? classes.cancelDispatchHeaderLabel : ''
        }`}
        valueClassName={classes.headerRowValue}
        rowClassName={classes.additionalStopsRowContainer}
      />
    </div>
  );
};

export default withStyles(styles)(DriverAdditionalStopPopup);
